import { __makeTemplateObject } from "tslib";
import MenuList from "@material-ui/core/MenuList";
import { alpha } from "@material-ui/core/styles";
import styled from "styled-components";
export var CustomMenuList = styled(MenuList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t> li:hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\t> li:hover {\n\t\tbackground-color: ", ";\n\t}\n"])), function (props) { return alpha(props.theme.palette.background.paper, 0.08); });
var templateObject_1;
//# sourceMappingURL=styles.js.map